import styled from 'styled-components'

const PopupStyle = styled.div``
export default PopupStyle
